import React from "react";
import PropTypes from "prop-types";

import "./Row.css";

function Row({
  className,
  width,
  height,
  spacing,
  padding,
  alignmentHorizontal,
  alignmentVertical,
  style,
  children,
}) {
  return (
    <div
      className={`${className} row row-spacing-${spacing} row-padding-${padding} row-alignment-horizontal-${alignmentHorizontal} row-alignment-vertical-${alignmentVertical}`}
      style={{ ...(width && { width }), ...(height && { height }), ...style }}
    >
      {children}
    </div>
  );
}

Row.propTypes = {
  className: PropTypes.string,
  width: PropTypes.any,
  height: PropTypes.any,
  spacing: PropTypes.oneOf(["small", "medium", "large"]),
  padding: PropTypes.oneOf(["small", "medium", "large"]),
  alignmentHorizontal: PropTypes.oneOf(["left", "center", "right"]),
  alignmentVertical: PropTypes.oneOf(["top", "center", "bottom"]),
  style: PropTypes.object,
};

export default Row;
